import { useTranslation } from 'react-i18next';

/**
 * Loading spinner component
 * Accessible loading indicator with ARIA attributes
 */
export function LoadingSpinner() {
  const { t } = useTranslation('common');

  return (
    <div
      className="flex min-h-screen items-center justify-center"
      role="status"
      aria-label={t('common.loading')}
    >
      <div
        className="h-8 w-8 animate-spin rounded-full border-4 border-muted border-t-primary"
        aria-hidden="true"
      />
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  );
}

